import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const badgeDefaultVariants = {
  "variant": "dot",
  "size": "md",
  "overlay": false,
  "overlap": "rectangular"
}
const badgeCompoundVariants = [
  {
    "variant": "dot",
    "size": "xs",
    "css": {
      "badge": {
        "width": "5px",
        "height": "5px"
      }
    }
  },
  {
    "variant": "dot",
    "size": "sm",
    "css": {
      "badge": {
        "width": "6px",
        "height": "6px"
      }
    }
  },
  {
    "variant": "dot",
    "size": "md",
    "css": {
      "badge": {
        "width": "6px",
        "height": "6px"
      }
    }
  },
  {
    "variant": "dot",
    "size": "lg",
    "css": {
      "badge": {
        "width": "8px",
        "height": "8px"
      }
    }
  },
  {
    "variant": "dot",
    "size": "xl",
    "css": {
      "badge": {
        "width": "8px",
        "height": "8px"
      }
    }
  },
  {
    "variant": "dot",
    "overlay": true,
    "overlap": "rectangular",
    "size": "xs",
    "css": {
      "badge": {
        "right": "-4",
        "top": "1px"
      }
    }
  },
  {
    "variant": "dot",
    "overlay": true,
    "overlap": "rectangular",
    "size": "sm",
    "css": {
      "badge": {
        "right": "-4",
        "top": "1px"
      }
    }
  },
  {
    "variant": "dot",
    "overlay": true,
    "overlap": "rectangular",
    "size": "md",
    "css": {
      "badge": {
        "right": "-4",
        "top": "1px"
      }
    }
  },
  {
    "variant": "dot",
    "overlay": true,
    "overlap": "rectangular",
    "size": "lg",
    "css": {
      "badge": {
        "right": "-6",
        "top": "1px"
      }
    }
  },
  {
    "variant": "dot",
    "overlay": true,
    "overlap": "rectangular",
    "size": "xl",
    "css": {
      "badge": {
        "right": "-6",
        "top": "2px"
      }
    }
  },
  {
    "variant": "number",
    "overlay": true,
    "overlap": "rectangular",
    "size": "sm",
    "css": {
      "badge": {
        "left": "calc(100% - 5px)",
        "top": "-4px"
      }
    }
  },
  {
    "variant": "number",
    "overlay": true,
    "overlap": "rectangular",
    "size": "md",
    "css": {
      "badge": {
        "left": "calc(100% - 6px)",
        "top": "-5px"
      }
    }
  },
  {
    "variant": "number",
    "overlay": true,
    "overlap": "rectangular",
    "size": "lg",
    "css": {
      "badge": {
        "left": "calc(100% - 6px)",
        "top": "-3px"
      }
    }
  },
  {
    "variant": "number",
    "overlay": true,
    "overlap": "rectangular",
    "size": "xl",
    "css": {
      "badge": {
        "left": "calc(100% - 7px)",
        "top": "-1px"
      }
    }
  },
  {
    "variant": "dot",
    "overlay": true,
    "overlap": "circular",
    "css": {
      "badge": {
        "top": "14%",
        "right": "14%",
        "transform": "translate(50%, -50%)"
      }
    }
  },
  {
    "variant": "number",
    "overlay": true,
    "overlap": "circular",
    "css": {
      "badge": {
        "left": "calc(85.36% - 3px)",
        "bottom": "calc(85.36% - 3px)"
      }
    }
  }
]

const badgeSlotNames = [
  [
    "root",
    "badge__root"
  ],
  [
    "badge",
    "badge__badge"
  ],
  [
    "srOnly",
    "badge__srOnly"
  ]
]
const badgeSlotFns = /* @__PURE__ */ badgeSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, badgeDefaultVariants, getSlotCompoundVariant(badgeCompoundVariants, slotName))])

const badgeFn = memo((props = {}) => {
  return Object.fromEntries(badgeSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const badgeVariantKeys = [
  "variant",
  "size",
  "overlay",
  "overlap"
]
const getVariantProps = (variants) => ({ ...badgeDefaultVariants, ...compact(variants) })

export const badge = /* @__PURE__ */ Object.assign(badgeFn, {
  __recipe__: false,
  __name__: 'badge',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: badgeVariantKeys,
  variantMap: {
  "variant": [
    "dot",
    "number"
  ],
  "size": [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
  ],
  "overlay": [
    "true",
    "false"
  ],
  "overlap": [
    "rectangular",
    "circular"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, badgeVariantKeys)
  },
  getVariantProps
})